import { FilterState } from '@components/Table/TableContext';

import eventService from '@service/eventService';

export enum TableServices {
  SetTableFilter = 'SetTableFilter',
  ResetTableFilters = 'ResetTableFilters',
  ResetTablePagination = 'ResetTablePagination',
  ResetTableSelected = 'ResetTableSelected',
}

export const filter = (columnId: string, value: unknown) => {
  eventService.emit(TableServices.SetTableFilter, columnId, value);
};

export const resetFilters = (newState?: FilterState) => {
  eventService.emit(TableServices.ResetTableFilters, newState);
};

export const resetPagination = () => {
  eventService.emit(TableServices.ResetTablePagination);
};

export const resetSelected = () => {
  eventService.emit(TableServices.ResetTableSelected);
};
